import { Component, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MENU_ITEMS } from './menu-items';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuHeaderComponent } from './menu-header/menu-header.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    host: { class: 'theme-dark' },
    imports: [MenuItemComponent, MenuHeaderComponent, TranslatePipe],
})
export class SidebarComponent {
    readonly menuItems = MENU_ITEMS;

    /** A menu item was clicked — the current page's too, which navigates nowhere. */
    readonly picked = output<void>();

    private readonly collapsedHeaders = signal(new Set(this.menuItems.filter((item) => item.collapsed).map((item) => item.label)));

    isCollapsed(label: string): boolean {
        return this.collapsedHeaders().has(label);
    }

    toggleHeader(label: string): void {
        const next = new Set(this.collapsedHeaders());
        if (next.has(label)) {
            next.delete(label);
        } else {
            next.add(label);
        }
        this.collapsedHeaders.set(next);
    }
}
